const Error = () => {
  return (
    <div className="flex flex-col justify-center items-center h-full px-6">
      <div className="text-6xl md:text-8xl mb-4 opacity-20">🔗</div>
      <h1 className="text-xl md:text-4xl font-bold text-newDarkBlack dark:text-[#FAFAFA] mb-4 text-center">
        Invalid Link
      </h1>
      <p className="text-md md:text-md text-newOffBlack dark:text-offGrey text-center max-w-md leading-relaxed">
        The event link you're trying to access doesn't exist or has expired. Please check the URL and try again.
      </p>
    </div>
  )
}

export default Error
